import { useState } from 'react';
import {
  Carousel,
  CarouselItem,
  CarouselControl,
  CarouselIndicators,
  CarouselCaption
} from 'reactstrap';

const items = [
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1714130717/VantageFit/2023/Employee_Wellness_Calendar-1.png',
    altText: 'The Ultimate Guide For Employee Wellness Calendar',
    caption: 'The Ultimate Guide For Employee Wellness Calendar',
    imagealtText:'The Ultimate Guide For Employee Wellness Calendar Slide 1'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1714130717/VantageFit/2023/Employee_Wellness_Calendar-2.png',
    altText: 'The Ultimate Guide For Employee Wellness Calendar',
    caption: 'The Ultimate Guide For Employee Wellness Calendar',
    imagealtText:'The Ultimate Guide For Employee Wellness Calendar Slide 2'
  },
  {
    src: 'https://res.cloudinary.com/vantagecircle/image/upload/v1714130717/VantageFit/2023/Employee_Wellness_Calendar-3.png',
    altText: 'The Ultimate Guide For Employee Wellness Calendar',
    caption: 'The Ultimate Guide For Employee Wellness Calendar',
    imagealtText:'The Ultimate Guide For Employee Wellness Calendar Slide 3'
  }
];

const EmpWellnessCarousel = (props) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  }

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  }

  const goToIndex = (newIndex) => {
    if (animating) return;
    setActiveIndex(newIndex);
  }

  const slides = items.map((item) => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.src}
      >
      <div className="row ">
      <div className="col-lg-12 col-md-12 col-xs-12 col-sm-12 pclr text-center">
      <img src={item.src} alt={item.imagealtText} className="img_shadow max-w" width="530" height="387"/>
      </div> </div>

      </CarouselItem>
    );
  });

  return (
    <Carousel
      activeIndex={activeIndex}
      next={next}
      previous={previous}
    >
      <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} className="commonindicator"/>
      {slides}
      <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
      <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
    </Carousel>
  );
}

export default EmpWellnessCarousel;



